import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ValidatorBar } from './components/ValidatorBar';
import { PainSection } from './components/PainSection';
import { AgitationSection } from './components/AgitationSection';
import { VillainSection } from './components/VillainSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { SevenDayPlan } from './components/SevenDayPlan';
import { BonusSection } from './components/BonusSection';
import { TestimonialSlider } from './components/TestimonialSlider';
import { ValueStack } from './components/ValueStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { EmotionalClose } from './components/EmotionalClose';
import { FAQSection } from './components/FAQSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { StickyMobileCTA } from './components/StickyMobileCTA';
declare global {
  interface Window {
    fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // 1. Meta Pixel Initialization
    const initMetaPixel = () => {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        
        fbq('init', '3099001053617513');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=3099001053617513&ev=PageView&noscript=1"/>`;
      document.head.appendChild(noscript);
    };
    // 2. Clarity Initialization
    const initClarity = () => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "vno34ndnus");
      `;
      document.head.appendChild(script);
    };
    initMetaPixel();
    initClarity();
    // 3. AddToCart Event Listeners - ONLY for purchase buttons
    const handleAddToCart = () => {
      if (window.fbq) {
        window.fbq('track', 'AddToCart', {
          content_name: 'Noches de Paz',
          currency: 'COP',
          value: 29999
        });
      }
    };
    // Wait for components to mount
    const timer = setTimeout(() => {
      const buyButtons = [document.getElementById('btn-compra-principal'), document.getElementById('btn-compra-cierre'), document.getElementById('btn-compra-faq'), document.getElementById('btn-compra-sticky')];
      buyButtons.forEach(btn => {
        if (btn) {
          btn.addEventListener('click', handleAddToCart);
        }
      });
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-warm-100 text-text-body selection:bg-primary-100 selection:text-primary-600" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ValidatorBar data-id="element-2" />
      <PainSection data-id="element-3" />
      <AgitationSection data-id="element-4" />
      <VillainSection data-id="element-5" />
      <MechanismSection data-id="element-6" />
      <ProductSection data-id="element-7" />
      <SevenDayPlan data-id="element-8" />
      <BonusSection data-id="element-9" />
      <TestimonialSlider data-id="element-10" />
      <ValueStack data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <UrgencySection data-id="element-13" />
      <EmotionalClose data-id="element-14" />
      <FAQSection data-id="element-15" />

      {/* Interactive Overlays */}
      <PurchaseNotification data-id="element-16" />
      <StickyMobileCTA data-id="element-17" />
    </div>;
}